import styled from 'styled-components';
import { palette } from 'styled-theme';

export const EmptyWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  text-align: center;
  width: 100%;

  h1.search-empty-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0px;
    color: ${palette('grayscale', 0)};
  }

  p.search-empty-message {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0px;
    color: ${palette('grayscale', 7)};
  }
`;
